var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('show-list',{attrs:{"title":"Movies Results","shows":_vm.movies,"rows":false}}),_c('show-list',{attrs:{"title":"TV Show Results","shows":_vm.tvShows,"rows":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }